import { MemberList } from '@tribeplatform/react-components/MemberList';
export const MemberListBlock = MemberList;
//# sourceMappingURL=Block.js.map